<div #selectContainer>
  <app-main-library-form
    [playlist]="playlist"
    [editItem]="editItem"
    [editItemType]="libraryEditItemTypes.EditPlaylist"
    [existedTitles]="existedTitles"
    (exit)="exit()"
    (locationChanged)="playlist.MachinePhysicalAddress = $event"
  >
    <ng-container content>
      <ul
        class="items-list items-selection-area"
        *ngIf="playlist?.PlaylistItems?.length"
        cdkDropList
        (cdkDropListDropped)="drop($event)"
      >
        <li *ngFor="let item of playlist.PlaylistItems; let id = index"
          cdkDrag (cdkDragStarted)="selection.cancel()" [cdkDragDisabled]="item.PlaylistItemType === playlistItemType.Foreground">
            <playlist-item
              [item]="item"
              [playlist]="playlist"
              (itemDeleted)="onItemDeleted($event)"
              (editItem)="onEditItem(item)"
              (click)="$event.stopPropagation()"
              [id]="item.PlaylistFileName ? id : null"
              data-selection-type="id"
              [clickOutside]="selectedItems"
              [parentComponent]="selectContainer"
            ></playlist-item>
        </li>
      </ul>
    </ng-container>
    <ng-container footer>
      @let itemToConvert = convertingItem$ | async;

      <button
        class="playlist-submit"
        [ngClass]="{ 'loading': isLoading }"
        type="button"
        (click)="submit()"
        [disabled]="!playlist?.PlaylistItems?.length || libraryFormComponent?.form?.invalid || isLoading || itemToConvert">
        Finish
      </button>

      <div class="new-item-button" (click)="onAddItem()" [class.isAnimated]="isTitleFocused && !playlist.PlaylistItems.length">
        <mat-icon matTooltip="Add new Item" svgIcon="add"></mat-icon>
        <span>Add New Item...</span>
      </div>

      @if (itemToConvert) {
        <files-progress-bar [item]="itemToConvert" [showSimplifiedDetails]="true"></files-progress-bar>
      }
    </ng-container>
  </app-main-library-form>
</div>
